import React from "react";
import "../styles/PricingSection.css";
import price from "../images/price.png";

function PricingSection() {
  return (
    <div className="pricing-section" id="pricing-section">
      <h2 className="pricing-title">ご利用料金</h2>
      <p className="pricing-description">
        お客様のご要望や目的に最適なプランをご提案させていただきます。詳細なお見積りについては、お気軽にご相談ください。
      </p>
      <img src={price} alt="price icon" className="price-icon" />
    </div>
  );
}

export default PricingSection;
